<template>
    <li class="list-group-item d-flex align-items-center">
        <div class="list-group-item-leading d-flex flex-column align-items-center">
            <PhUser/>
        </div>
        <div class="list-body">
            <h4>{{props.fio}}</h4>
            <div class="list-desc">
                <p v-if="faction">
                  {{$i18n.locale === 'kg' ? faction.titleKg : faction.titleRu}}
                </p>
                <p v-if="committee">
                  {{$i18n.locale === 'kg' ? committee.titleKg : committee.titleRu}}
                </p>
            </div>
        </div>
        <router-link :to="{name: 'deputies.show', params: {id: props.id}}" class="stretched-link"/>
    </li>
</template>

<script setup>
import {PhUser} from "@phosphor-icons/vue";
import {computed} from "vue";

const props = defineProps({
    id: {
        type: Number,
        required: true
    },
    fio: {
        type: String,
        required: false,
    },
    factions : {
        type: String,
        required: false,
    },
    committees : {
        type: String,
        required: false,
    }
});

const faction = computed( () => {
  if (Array.isArray(props.factions) && props.factions.length > 0) {
    return {
      titleKg: props.factions[0].titleKg,
      titleRu: props.factions[0].titleRu,
    };
  }
  return null;
});

const committee = computed(() => {
  if (Array.isArray(props.committees) && props.committees.length > 0) {
    return {
      titleKg: props.committees[0].titleKg,
      titleRu: props.committees[0].titleRu,
    }
  }
  return null;
})

</script>